import { authStateKey, authStates, useAuthContext } from '@picsart/growth-rc/AuthContext';
import { authorizationHeader } from '@picsart/growth-rc/services/auth';
import { getStorage } from '@picsart/growth-rc/services/browserStorage';
import { USER_KEY_COOKIE_NAME } from '@picsart/rc/configs/constants';
import { getCookie } from '@picsart/rc/cookie';
import HttpService from '@picsart/rc/services/http';
import MonetizationPopup from 'components/MonetizationPopup';
import { useEffect } from 'react';
import { PageProps } from './types';
import { PageType } from '../constants/pages';

function MonetizationProviderWrapper({
  storageDataUnits,
  user,
  children,
  monetizationRequired,
  pageType,
}: Readonly<PageProps>) {
  const { isStorageFeature, promoRequired, scope } = storageDataUnits || {};
  const { tokenDataRef } = useAuthContext();

  useEffect(() => {
    HttpService.registerInterceptor({
      request: (url, options) => ({
        url,
        options: {
          ...options,
          headers: {
            ...options?.headers,
            ...authorizationHeader(tokenDataRef?.current?.access_token),
          },
        },
      }),
    });
  }, [tokenDataRef]);

  const isMonetization =
    pageType === PageType.LandingOrHub ||
    monetizationRequired ||
    (isStorageFeature && user) ||
    getStorage(authStateKey) === authStates.authorized ||
    getCookie(USER_KEY_COOKIE_NAME);

  if (isMonetization) {
    return (
      <MonetizationPopup promoRequired={promoRequired} scope={scope}>
        {children}
      </MonetizationPopup>
    );
  }
  return <>{children}</>;
}

export default MonetizationProviderWrapper;
